/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BuyoutRightsMultiEditDto { 
    buyoutRights: object;
    _id: Array<string>;
    deletedBuyoutRightIds?: Array<string>;
    deletedBuyoutRightTerritoryIds?: object;
}

